import React, { useMemo, useState } from 'react';

type Props = {
  title: string;
  code: string;
};

export const CodeSnippet = ({ title, code }: Props) => {
  const [copied, setCopied] = useState(false);
  const languageLabel = useMemo(() => {
    const explicitLang = title.match(/\(([^)]+)\)$/);
    if (explicitLang) {
      return explicitLang[1];
    }
    if (title.toLowerCase().includes('curl')) {
      return 'cURL';
    }
    if (title.toLowerCase().includes('js')) {
      return 'JavaScript';
    }
    return 'Snippet';
  }, [title]);

  const displayTitle = useMemo(() => title.replace(/\s*\(([^)]+)\)$/, '').trim() || title, [title]);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="card snippet-card">
      <div className="snippet-header">
        <div>
          <div className="snippet-title">
            <span className="snippet-language">{languageLabel}</span>
            <strong>{displayTitle}</strong>
          </div>
          <p className="card-subtitle">Copy-ready payload you can run against Supabase Functions.</p>
        </div>
        <button
          type="button"
          onClick={() => {
            void handleCopy();
          }}
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <pre className="snippet-body">
        <code>{code}</code>
      </pre>
    </section>
  );
};

export default CodeSnippet;

